import { LineResultBuilder } from "ags/integration/builders/results/line-result-builder";
import { AgsWin, AgsWinTypes } from "ags/integration/schema/ags-spin-response-schema";

export class ThemeLineResultBuilder extends LineResultBuilder {
    public override filter(response: AgsWin): boolean {
        const isLineOrJackpotWin = response.evaluationType === AgsWinTypes.LINES || response.evaluationType === AgsWinTypes.JACKPOT;
        return isLineOrJackpotWin && response.lineNumber !== undefined;
    }
}
